import { render, staticRenderFns } from "./Step2AISuggestions.vue?vue&type=template&id=4a715905&scoped=true"
import script from "./Step2AISuggestions.vue?vue&type=script&lang=js"
export * from "./Step2AISuggestions.vue?vue&type=script&lang=js"
import style0 from "./Step2AISuggestions.vue?vue&type=style&index=0&id=4a715905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a715905",
  null
  
)

export default component.exports